import React from "react";
import { Grid, IconButton, Tooltip } from "@mui/material";
import {
  Delete,
  RemoveModerator,
  Send,
  VerifiedUser,
  Visibility,
  MonetizationOn,
} from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslation } from "react-i18next";
/**
 * @param users
 * @param methods
 * @return {{columns: [{headerName: string, field: string, width: number},{headerName: string, field: string, width: number},{headerName: string, field: string, width: number},{headerName: string, field: string, width: number},{headerName: string, field: string, width: number},null], rows: *[]}}
 */
const UsersDocumentTable = (users = [], methods = {}) => {
  const {
    navigate,
    approvedDocuments,
    approveHandler,
    deleteHandler,
    openModal,
    resetEmailHandler,
  } = methods;
  const { language, setLanguage, t } = useTranslation();

  const columns = [
    { field: "id", headerName: "#", width: 80 },
    {
      field: "fullName",
      headerName: t("fields.fullName"),
      minWidth: 150,
      flex: 1,
    },

    { field: "email", headerName: t("fields.email"), minWidth: 150, flex: 1 },
    {
      field: "profile",
      headerName: t("fields.profileCompleted"),
      minWidth: 100,
      flex: 1,
      renderCell: (props) => {
        const isCompleted = props.row.profile;
        return <span style={{ color: "green" }}>{isCompleted}% </span>;
      },
    },

    {
      field: "verified",
      headerName: t("fields.verified"),
      width: 150,
      renderCell: (props) => {
        const isVerified = props.row.verified;
        return isVerified ? (
          <span style={{ color: "green" }}>Verified </span>
        ) : (
          <span style={{ color: "red" }}>Not Verified</span>
        );
      },
    },
    {
      field: "isKYCCompleted",
      headerName: t("fields.kycStatus"),
      minWidth: 150,
      flex: 1,
    },
    {
      field: "actions",
      headerName: t("fields.actions"),
      minWidth: 100,
      flex: 1,
      renderCell: (props) => {
        const isVerified = props.row.verified;
        const id = props.row._id;
        return (
          <Grid container>
            <Grid item>
              <Tooltip title="View" arrow>
                <IconButton
                  size="small"
                  onClick={() => navigate(`/admin/users-document/${id}`)}
                >
                  {/* <Visibility /> */}
                  <svg
                    width="22"
                    height="15"
                    viewBox="0 0 15 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_90_6833)">
                      <path
                        d="M15.0002 3.91102C14.9235 3.79972 14.8608 3.67469 14.7679 3.57934C13.502 2.28268 12.0589 1.24608 10.3751 0.576048C9.22401 0.118227 8.03039 -0.0902777 6.79091 0.0358639C5.82002 0.134552 4.89903 0.420226 4.01914 0.836124C2.57125 1.52063 1.30424 2.46484 0.189885 3.62089C-0.062928 3.8832 -0.0636618 4.11767 0.189885 4.37923C1.46569 5.69482 2.92239 6.74551 4.62494 7.42333C5.77562 7.88153 6.96961 8.08966 8.20909 7.96389C9.17998 7.8652 10.101 7.57916 10.9809 7.164C12.4111 6.48877 13.6642 5.55792 14.7679 4.42041C14.8604 4.32506 14.9235 4.20003 15.0002 4.08873V3.91102ZM10.5758 4.00674C10.5699 5.71893 9.18255 7.11577 7.49321 7.10983C5.79984 7.1039 4.41836 5.70112 4.42423 3.99301C4.4301 2.28082 5.81745 0.883984 7.50679 0.88992C9.20016 0.895855 10.5816 2.29863 10.5758 4.00674Z"
                        fill="#363131"
                      />
                      <path
                        d="M9.63637 3.60977C9.62023 2.88223 8.85482 2.04487 8.02849 1.84304C7.05063 1.60412 6.03865 2.05749 5.56641 2.94642C5.09931 3.8257 5.2736 4.91905 5.97847 5.59985C6.69325 6.29029 7.74229 6.38675 8.46918 5.96603C7.95401 5.49931 7.76724 4.93649 8.08684 4.29539C8.4046 3.65763 8.95572 3.45877 9.63637 3.60977Z"
                        fill="#363131"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_90_6833">
                        <rect
                          width="15"
                          height="8"
                          fill="white"
                          transform="matrix(1 0 0 -1 0 8)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item>
              {props.row?.isAdminApproved ? (
                <Tooltip title="Approved Documents" arrow>
                  <IconButton size="small">
                    {/* <RemoveModerator className="success"  /> */}

                    <svg
                      width="22"
                      height="25"
                      viewBox="0 0 12 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.00897029 3.6454C0.00897029 3.15225 -0.0149091 2.65789 0.0152543 2.16678C0.050026 1.60226 0.45011 1.17274 1.0274 1.0467C2.6202 0.699585 4.21551 0.363889 5.80872 0.0188099C6.06259 -0.0362558 6.29594 0.0420599 6.53264 0.0938625C7.97797 0.410388 9.42037 0.742007 10.8678 1.04997C11.5171 1.18783 11.9985 1.65365 11.9977 2.45516C11.9972 3.25912 12.0035 4.06308 11.9964 4.86704C11.9796 6.67238 11.4912 8.33945 10.4283 9.83112C9.44383 11.2131 8.15015 12.2259 6.55945 12.8813C6.17152 13.0412 5.79322 13.04 5.4078 12.874C2.67424 11.6964 0.935238 9.69977 0.222628 6.8747C0.0969468 6.37584 0.0496071 5.85292 0.0186058 5.33816C-0.0157469 4.77567 0.010646 4.20992 0.010646 3.6454C0.00980816 3.6454 0.00938922 3.6454 0.00855135 3.6454H0.00897029ZM5.48488 6.72337C5.42958 6.67279 5.38727 6.63567 5.34621 6.59692C5.05045 6.31629 4.75635 6.03403 4.45933 5.75462C4.169 5.48133 3.74755 5.47195 3.47231 5.72933C3.18911 5.99365 3.17613 6.41174 3.46645 6.69849C3.9654 7.19122 4.47231 7.67662 4.98593 8.15508C5.28589 8.43449 5.73289 8.41776 6.03159 8.13591C6.31689 7.8667 6.60093 7.59626 6.88413 7.32501C7.64114 6.601 8.39565 5.87454 9.15434 5.15257C9.36381 4.95311 9.44676 4.71775 9.37261 4.44528C9.2331 3.93092 8.59381 3.78245 8.18534 4.1675C7.32946 4.97513 6.47692 5.78603 5.62313 6.59529C5.58249 6.63404 5.5406 6.67157 5.48446 6.72337H5.48488Z"
                        fill="#20BF55"
                      />
                    </svg>
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Approved Documents" arrow>
                  <IconButton
                    size="small"
                    onClick={() => approvedDocuments(id)}
                  >
                    {/* <VerifiedUser className="failure" /> */}

                    <svg
                      width="22"
                      height="25"
                      viewBox="0 0 9 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.651086 12.0005C0.499479 11.8273 0.347871 11.6534 0.195514 11.4811C0.129091 11.4061 0.0604178 11.334 0 11.2686C2.72255 8.26379 5.43798 5.26648 8.1474 2.27539C8.36017 2.51108 8.58195 2.7563 8.83076 3.03135C8.80674 3.0475 8.76358 3.06531 8.73394 3.09762C7.82242 4.10169 6.91352 5.10867 5.999 6.10943C5.90556 6.21174 5.85302 6.31074 5.87254 6.45489C5.87854 6.50045 5.87366 6.54809 5.87366 6.62306C5.91419 6.58205 5.94083 6.55596 5.96673 6.52862C6.19676 6.28588 6.41104 6.02161 6.65909 5.80456C7.27078 5.26897 8.1459 5.22962 8.80899 5.68112C9.02139 5.82568 9.06042 6.06303 8.90581 6.27843C8.87954 6.31488 8.84877 6.3476 8.81875 6.38074C7.77814 7.52938 6.73827 8.67884 5.69654 9.82665C5.34116 10.2181 4.93212 10.518 4.45215 10.692C3.69524 10.9666 2.95072 10.945 2.22195 10.5735C2.10186 10.5122 1.99416 10.5341 1.89885 10.6394C1.48981 11.0929 1.08077 11.5465 0.671726 12.0001H0.650336L0.651086 12.0005Z"
                        fill="#E0221E"
                      />
                      <path
                        d="M1.54626 5.09858C1.56614 5.10437 1.56952 5.10645 1.5729 5.10603C1.71625 5.08256 1.78793 4.99074 1.78793 4.83057C1.78793 3.64714 1.7883 2.46371 1.78755 1.28028C1.78755 1.0566 1.83258 0.85529 1.9932 0.702028C2.19059 0.513143 2.41537 0.485804 2.64653 0.595573C2.86832 0.700785 2.96926 0.91121 2.9869 1.17217C2.99028 1.2227 2.98878 1.27365 2.98878 1.3246C2.98878 2.42602 2.98878 3.52743 2.98878 4.62885C2.98878 4.67524 2.98878 4.72163 2.98878 4.78625C3.0612 4.7701 3.12537 4.75933 3.18767 4.73986C3.20493 4.73448 3.22294 4.70548 3.22745 4.68394C3.2342 4.65039 3.2297 4.61394 3.2297 4.57873C3.2297 3.30541 3.23007 2.03209 3.2297 0.758776C3.2297 0.545038 3.26572 0.346626 3.41395 0.193364C3.60984 -0.0096046 3.838 -0.0510268 4.08118 0.0608131C4.30971 0.16644 4.40991 0.379349 4.43055 0.643209C4.4343 0.689601 4.43242 0.736823 4.43242 0.78363C4.43242 1.95919 4.43242 3.13475 4.43242 4.31073C4.43242 4.35671 4.43242 4.4031 4.43242 4.45778C4.49172 4.44618 4.53975 4.43375 4.58816 4.42837C4.65421 4.42091 4.67297 4.38404 4.67259 4.31238C4.66959 3.92177 4.67109 3.53116 4.67109 3.14055C4.67109 2.51549 4.67109 1.89084 4.67109 1.26578C4.67109 0.999025 4.7484 0.772446 4.96455 0.631196C5.37809 0.361124 5.86181 0.661849 5.87307 1.19785C5.88095 1.55698 5.87495 1.91653 5.87495 2.27566C5.87495 2.8187 5.87382 3.36133 5.87607 3.90438C5.87607 3.97935 5.85956 4.03403 5.80965 4.08912C4.2219 5.83838 2.63565 7.5897 1.0494 9.34021C1.02501 9.36713 0.998742 9.39281 0.96722 9.42553C0.758948 9.10783 0.607715 8.76816 0.50114 8.40282C0.393063 8.03168 0.347656 7.65059 0.347656 7.26164C0.348032 5.44155 0.347656 3.62146 0.348032 1.80137C0.348032 1.43064 0.509771 1.17217 0.789344 1.08974C1.17212 0.976657 1.53162 1.26413 1.54325 1.70154C1.55113 2.00186 1.54626 2.30299 1.54626 2.60372C1.54626 3.39281 1.54626 4.18149 1.54626 4.97058C1.54626 5.01325 1.54626 5.0555 1.54626 5.09899V5.09858Z"
                        fill="#E0221E"
                      />
                    </svg>
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
            
          </Grid>
        );
      },
    },
  ];

  const rows =
    users.length === 0
      ? []
      : [
          ...users.map((user, id) => ({
            id: id + 1,
            fullName: user.name,
            email: user.email,
            profile: user.profileCompleted,
            verified: user.isVerified,
            isKYCCompleted: user.isKYCCompleted,
            isAdminApproved: user.isAdminApproved,
            _id: user._id,
          })),
        ];

  return { rows, columns };
};

export default UsersDocumentTable;
